<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>Ù</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.questionnaireDetail') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <h1>{{ title }}</h1>

      <v-text-field v-model="newQuestionnaire.label"
                    :label="$t('pages.questionnaireSettings.label')"
                    color="valid"
      />
      <v-textarea v-model="newQuestionnaire.description"
                  :label="$t('pages.questionnaireSettings.description')"
                  color="valid"
      />
      <div id="publication">
        <date-time-picker v-model="newQuestionnaire.publicationDate"
                          :label="$t('pages.questionnaireSettings.publicationDateAndTime')"
                          :button-now-translation="$t('pages.questionnaireSettings.publicationButtonNow')"
                          format="YYYY-MM-DDTHH:mm"
                          color="#47A4A9"
                          button-color="#6D98D5"
                          minute-interval="5"
        />

        <v-checkbox v-model="newQuestionnaire.isPublished"
                    :label="$t('pages.questionnaireSettings.isPublished')"
                    color="valid"
                    @change="autoFillDate"
        />
      </div>
      <div class="button-group">
        <v-btn color="valid"
               @click="saveInit"
               :disabled="cantSave"
        >{{ $t('components.buttons.save') }}
        </v-btn>
        <v-btn color="cancel" @click="$router.push({ name: 'questionnaireList' })">
          {{ $t('components.buttons.cancel') }}
        </v-btn>
      </div>
    </section>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'questionnaireSettings',
  components: {
    DateTimePicker
  },
  data () {
    return {
      /**
       * @type {QuestionnaireAir}
       */
      newQuestionnaire: {},
      duplicateLabel: '',
      isDuplication: this.$route.name === 'questionnaireDuplication',
      isUpdate: this.$route.name === 'questionnairePublication'
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'questionnaire',
      'questionnaireSettings'
    ]),
    ...mapGetters('Repositories', [
      'repositorySelectedId'
    ]),
    title () {
      return this.isUpdate
        ? this.$t('pages.questionnaireSettings.title.update',
          { label: this.questionnaire.label })
        : this.isDuplication
          ? this.$t('pages.questionnaireSettings.title.duplicate',
            { label: this.duplicateLabel })
          : this.$t('pages.questionnaireSettings.title.create')
    },
    cantSave () {
      return !(this.newQuestionnaire.label && this.newQuestionnaire.label.length > 0)
    }
  },
  async created () {
    this.isUpdate ? await this.questionnaireLoad(this.$route.params.id)
      : this.isDuplication
        ? await this.questionnaireCopy(this.$route.params.id)
        : this.questionnaireInit(this.repositorySelectedId)

    this.newQuestionnaire = {
      ...this.questionnaireSettings
    }
    this.setPublicationDate()
    this.duplicateLabel = this.newQuestionnaire.label.slice(9)
  },
  methods: {
    ...mapActions('Questionnaires', [
      'questionnaireInit',
      'questionnaireCopy',
      'questionnaireLoad',
      'saveCopy',
      'questionnaireSave'
    ]),
    async saveInit () {
      this.setOffset()
      if (this.isDuplication) {
        await this.saveCopy(this.newQuestionnaire)
      } else {
        await this.questionnaireSave({
          questionnaire: this.newQuestionnaire,
          isUpdate: this.isUpdate
        })
      }
      if (!this.isUpdate) {
        await this.$router.push({
          name: 'questionnaireCreation',
          params: { id: this.questionnaire.id }
        })
      }
    },
    setOffset () {
      if (this.newQuestionnaire.publicationDate) {
        const offsetMin = -new Date(this.newQuestionnaire.publicationDate).getTimezoneOffset()
        const offsetHour = (Math.sign(offsetMin) >= 0 ? '+' : '') +
          String(Math.floor(offsetMin / 60)).padStart(2, '0') +
          ':' + String(offsetMin % 60).padStart(2, '0')

        this.newQuestionnaire.publicationDate += offsetHour
      }
    },
    setPublicationDate (autoFill = false) {
      const publicationDate = this.newQuestionnaire.publicationDate
      if (publicationDate || autoFill) {
        const dateTime = autoFill ? new Date() : new Date(publicationDate)
        const publicationDay = [dateTime.getFullYear(), dateTime.getMonth() + 1, dateTime.getDate()]
          .map(dateItem => String(dateItem).padStart(2, '0'))
          .join('-')
        const publicationTime = [dateTime.getHours(), dateTime.getMinutes()]
          .map(dateItem => String(dateItem).padStart(2, '0'))
          .join(':')
        this.newQuestionnaire.publicationDate = `${publicationDay}T${publicationTime}`
      }
    },
    autoFillDate () {
      if (this.newQuestionnaire.isPublished && this.newQuestionnaire.publicationDate === null) {
        this.setPublicationDate(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  #app__ernest {
    .v-progress-linear {
      margin: 0;
    }

    .date-time-picker::v-deep {
      z-index: 2000;

      .header-picker {
        div, span {
          color: white;
        }
      }

      button.active .time-picker-column-item-text {
        color: white;
      }

      button.time-picker-column-item:hover .time-picker-column-item-text {
        color: #3A3A3A;
      }
    }

    .button-group {
      margin-top: 30px;
      display: flex;
      flex-direction: column;

      .v-btn{
        margin: 15px 30px;

        &:last-child {
          margin-top: 0;
        }
      }
    }
  }
</style>
